import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';

import {
  clearSession as clearPersistedSession,
  getSession,
} from '@/services/authService';

const SessionContext = createContext(null);

export function SessionProvider({ children }) {
  const [session, setSessionState] = useState(() => getSession());

  const setSession = useCallback((next) => {
    setSessionState(next);
  }, []);

  const clearSession = useCallback(() => {
    clearPersistedSession();
    setSessionState(null);
  }, []);

  const value = useMemo(
    () => ({
      user: session?.user || null,
      companies: session?.companies || [],
      fys: session?.fys || [],
      permissioncode: session?.permissioncode || [],
      erpversion: session?.erpversion || '',
      isAuthenticated: Boolean(session?.user),
      setSession,
      clearSession,
    }),
    [session, setSession, clearSession],
  );

  return (
    <SessionContext.Provider value={value}>{children}</SessionContext.Provider>
  );
}

export function useSession() {
  const ctx = useContext(SessionContext);
  if (!ctx) throw new Error('useSession must be used inside <SessionProvider>');
  return ctx;
}
